import styled from 'styled-components'

import { HeightClass } from '~/utils/enum/classes'
import { Variant as TextClass, typographyMap } from '../Text/Text.styles'

export const Container = styled.div<{ type: string; heightClass: HeightClass }>`
  max-width: 356px;
  border-radius: 8px;
  padding: ${({ theme, heightClass }) =>
    theme.feedbackCard.sizes[heightClass].padding}px;
  background-color: ${({ theme, type }) => theme.feedbackCard.type[type]};

  @media (max-width: 767px) {
    margin: auto;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Title = styled.h2<{ heightClass: HeightClass }>`
  ${({ theme, heightClass }) =>
    typographyMap[
      theme.feedbackCard.sizes[heightClass].titleTextClass as TextClass
    ]}
  margin-bottom: 0;
  color: ${({ theme }) => theme.colors.blackText};
`

export const Description = styled.p<{ heightClass: HeightClass }>`
  ${({ theme, heightClass }) =>
    typographyMap[
      theme.feedbackCard.sizes[heightClass].descriptionTextClass as TextClass
    ]}
  color: ${({ theme }) => theme.colors.blackText};
  margin: 0.5rem 0 0;
`
